module.exports = __webpack_public_path__ + "img/logo.0b4142a9.png";